module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-19.57f2776a.jpg";